import styled from 'styled-components';
import { Typography } from '../../foundation/Typography/styled.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

var getIconColor = function getIconColor(appearance) {
  switch (appearance) {
    case 'success':
      return themeGet('colors.green.500');
    case 'danger':
      return themeGet('colors.red.500');
    case 'warning':
      return themeGet('colors.yellow.500');
    case 'info':
    default:
      return themeGet('colors.blue.500');
  }
};
var StyledTitle = styled(Typography).withConfig({
  displayName: "StyledTitle",
  componentId: "sc-1pg97e6-0"
})(["line-height:", ";"], pxToRem(18));
var StyledMessage = styled(Typography).withConfig({
  displayName: "StyledMessage",
  componentId: "sc-1pg97e6-1"
})(["line-height:", ";"], pxToRem(18));
var ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-1pg97e6-2"
})(["display:flex;flex-direction:column;"]);
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1pg97e6-3"
})(["display:flex;align-items:stretch;gap:", ";padding:", ";border-radius:", ";border:solid ", " ", ";background-color:", ";box-shadow:", ";", ""], themeGet('spacing.lg'), themeGet('spacing.lg'), themeGet('borderRadius.lg'), pxToRem(1), themeGet('colors.border.100'), themeGet('colors.background.50'), themeGet('dropShadow.100'), function (props) {
  return props.$onlyMessage && "\n    align-items: center;\n\n    " + ContentContainer + " {\n      justify-content: center;\n      min-height: " + pxToRem(36) + ";\n    }}\n  ";
});
var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1pg97e6-4"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;width:", ";height:", ";border-radius:", ";background-color:", ";[data-icon='falcon']{color:", ";}"], pxToRem(36), pxToRem(36), themeGet('borderRadius.lg'), themeGet('colors.background.75'), function (props) {
  return getIconColor(props.$appearance);
});

export { Container, ContentContainer, IconContainer, StyledMessage, StyledTitle };
